export default __webpack_public_path__ + "static/media/search-background.bc047f01.png";